import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import { getCurrencyLocaleValue } from "data/utils/formaters"

import gridStyles from "../../../components/Plans.module.css"

const PricingItem = ({
  isDiscountApplied,
  lang,
  price,
  subscriptionPeriod,
  discountDuration,
  discountPeriodUnit,
  showAsterisk,
}) => {
  const { t: translate } = useTranslate()

  const getDiscountedSubscriptionPeriod = () => {
    if (discountDuration === 1) {
      switch (discountPeriodUnit) {
        case "month":
          return translate("for the first month")
        case "year":
          return translate("for the first year")
        default:
          return ""
      }
    }

    switch (discountPeriodUnit) {
      case "month":
        return translate("for first {duration} months", {
          duration: discountDuration,
        })
      case "year":
        return translate("for first {duration} years", {
          duration: discountDuration,
        })
      default:
        return ""
    }
  }

  const getSubscriptionPeriod = () => {
    switch (subscriptionPeriod) {
      case "month":
        return translate("per month")
      case "year":
        return translate("per year")
      default:
        return ""
    }
  }

  return (
    <div
      className={`flex-container f-a-center ${isDiscountApplied ? "f-d-row f-j-center" : "f-d-col"
        }`}
    >
      {!isDiscountApplied && (
        <p
          className={
            isDiscountApplied
              ? "fs-14 w300 m-b-0 m-l-5 m-r-5"
              : `${gridStyles.mainPricingCurrency}`
          }
        >
          {getCurrencyLocaleValue({
            value: price.net_amount || 0,
            currency: price.currency,
            language: lang,
            fractionDigits: price.net_amount % 1 !== 0 ? 2 : 0,
          })}
          {showAsterisk && "*"}
        </p>
      )}

      <label className={`${gridStyles.perPeriodLabel} fs-14 w300 m-b-0 m-t-8`}>
        {isDiscountApplied
          ? getDiscountedSubscriptionPeriod()
          : getSubscriptionPeriod()}
      </label>
    </div>
  )
}

PricingItem.propTypes = {
  isDiscountApplied: PropTypes.bool,
  price: PropTypes.object,
  lang: PropTypes.string,
  subscriptionPeriod: PropTypes.oneOf(["month", "year", ""]),
  discountPeriodUnit: PropTypes.oneOf(["month", "year", ""]),
  discountDuration: PropTypes.number,
  showAsterisk: PropTypes.bool,
}
PricingItem.defaultProps = {
  isDiscountApplied: false,
  price: {},
  lang: "en",
  subscriptionPeriod: "",
  discountPeriodUnit: "",
  discountDuration: 0,
  showAsterisk: false,
}

export default PricingItem
